import React from 'react';
import { FC } from 'types';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { LIVE_EVENTS_COUNT_QUERY } from 'schema/Event/queries';
import {
  LiveEventsCountQuery,
  LiveEventsCountQueryVariables,
} from '__generated__/graphql/legacy/graphql';
import { genericToastAlert } from 'utils/toastHelpers';
import { getLayout } from 'components/Layouts/MainLayout';
import { useCommunityContext } from 'components/CommunityContext';
import EventsSkeleton from 'components/Events/components/EventsSkeleton/EventsSkeleton';
import EventListPage from 'components/Events/components/EventListPage/EventListPage';
import CommunityHeader from 'components/CommunityHeader/CommunityHeader';

export const EventsPage: FC = () => {
  const { community } = useCommunityContext();
  const { t } = useTranslation();

  const { loading, previousData } = useQuery<
    LiveEventsCountQuery,
    LiveEventsCountQueryVariables
  >(LIVE_EVENTS_COUNT_QUERY, {
    variables: {
      eventSourceId: community.id,
    },
    fetchPolicy: 'cache-first',
    onError: () => {
      genericToastAlert();
    },
  });

  const head = (
    <CommunityHeader pageTitle={t('pages-events_title', 'Events')} />
  );

  if (loading && !previousData) {
    return (
      <>
        {head}
        <EventsSkeleton />
      </>
    );
  }

  return (
    <>
      {head}
      <EventListPage />
    </>
  );
};

EventsPage.getLayout = getLayout;

export default EventsPage;
